import {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";

/**
 * Watcher hook for react-hook-form dropdown components
 *
 * @param {object} control React hook form control object
 * @param {string} name Fully qualified name of the object to watch .... e.g. form.dropdown_thig
 * @param {string=} namedField name of the dropdown return value to return. Defaults to 'value' if not set
 * @param {boolean=} isInt defines whether the final value returned is converted to an integer. Defaults to true if not set
 *
 * @returns {string|int|null} The return value of the dropdown
 *
 * @example
 *
 * const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + 'eyfs_group_id' }) ;
 *
 * // Or for a string value
 *
 * const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + 'eyfs_group_id', isInt: false, namedField: 'enc_group_id' }) ;
 *
 */
const useWatchDropdown = ( { control, name, namedField, isInt }) =>
{
    const [ value, setValue ] = useState ( null ) ;
    const watchField = namedField === undefined ? 'value' : namedField ;
    const intConvert = isInt === undefined ? true : isInt ;

    const meeting_location_type = useWatch({
        control: control,
        name: name,
    });

    /**
     * Sets the state of the dropdown
     *
     */
    useEffect(() => {
        if ( meeting_location_type === null || meeting_location_type === undefined )
        {
            setValue ( null ) ;
        }
        else
        {
            const returnValue = meeting_location_type[watchField] ;

            setValue( intConvert ? +(returnValue) : returnValue );
        }
    }, [ meeting_location_type ] ) ;

    return [ value ] ;
}

export default useWatchDropdown ;
